import AboutHero from '@/components/custom/ui/landing/about/aboutHero'
import { AboutPage } from '@/components/custom/ui/landing/about/aboutUs'
import FooterCmp from '@/components/custom/ui/landing/footer'
import { aboutConfig } from '@/constant/config/landing/about/aboutConfig'
import AboutConfig from '@/constant/config/landing/about/aboutheroConfig'
import footerConfig from '@/constant/config/landing/footerConfig'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_landing/aboutUs')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className='bg-myBlack'>
      <AboutHero {...AboutConfig}/>
      <AboutPage {...aboutConfig}/>
      <FooterCmp {...footerConfig} />
    </div>
  )
}
